module.exports = "http://cdn.realive.com.ua/src/views/player/documets/fibbadge/images/fib_logo.png";